module.exports = __webpack_public_path__ + "ac4e0a9293ef54108d8a9937a2a4931c.png";